module.exports = __webpack_public_path__ + "img/pex-card.11a5ff76.png";